module.exports = __webpack_public_path__ + "img/sld_mfm_crp_b1_dark.15e11046.svg";